import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Form from '../Form';
import { dataLabelsPropTypes } from '../Form/propTypes';
// import { Mode, modePropType } from './constants';
import SalesPointsTabContent from './SalesPointsTabContent';
import MarketSettingsToolbarContent from './MarketSettingsToolbarContent';
import LabelTabContent from './LabelTabContent';
import LocalUtensilsTabContent from './LocalUtensilsTabContent';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import { getHasRecalledError } from 'features/PpsiContainer/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { hasRecalledPPSIError } from 'features/PpsiContainer/actions';
import { fetchMarketSettings } from 'features/MarketSettingContainer/actions';
import FilterButtons from './FilterButtons';

const MarketSettingsForm = ({
  data,
  defaultData,
  showProgress,
  dataLabels,
  mode,
  onSave,
  onPublish,
  onUnpublish,
  onCreateDraft,
  oniFoodUpdatePpi,
  onGlobalUpdatePpi,
  setOpenConfirm,
  completePpiData = null,
  globalPpis
}) => {
  const hasRecalledError = useSelector(getHasRecalledError);
  const dispatch = useDispatch();

  return (
    <>
      <Form
        data={data}
        defaultData={defaultData}
        tabs={[
          {
            name: 'Sales_Points',
            label: 'marketSettings.salesPointsTab',
            TabContent: SalesPointsTabContent
            // visible: false
          },
          // {
          //   name: 'Local Utensils',
          //   label: 'marketSettings.localUtensilsTab',
          //   TabContent: LocalUtensilsTabContent
          //   //visible: false
          // },
          {
            name: 'Label',
            label: 'marketSettings.label',
            TabContent: LabelTabContent
            // visible: false
          },
          {
            name: 'Filtering_Button',
            label: 'marketSettings.filter',
            TabContent: FilterButtons
            // visible: false
          }
        ]}
        dataLabels={dataLabels}
        showProgress={showProgress}
        ToolbarContent={({ data: formData }) => (
          <MarketSettingsToolbarContent
            data={formData}
            mode={mode}
            onSave={onSave}
            onPublish={onPublish}
            oniFoodUpdatePpi={oniFoodUpdatePpi}
            onUnpublish={onUnpublish}
            onCreateDraft={onCreateDraft}
            completePpiData={completePpiData}
            onGlobalUpdatePpi={onGlobalUpdatePpi}
            setOpenConfirm={setOpenConfirm}
            globalPpis={globalPpis}
          />
        )}
      />
      <Dialog open={hasRecalledError}>
        <DialogContent>
          <DialogContentText component="div">
            The market settings have been modified by another user. Please
            reload the data and try again.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            key="stay"
            onClick={() => {
              dispatch(hasRecalledPPSIError(false));
              dispatch(fetchMarketSettings());
            }}
            color="primary"
            style={{ marginRight: '10px' }}
          >
            RELOAD
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

MarketSettingsForm.propTypes = {
  data: PropTypes.object,
  defaultData: PropTypes.object,
  dataLabels: PropTypes.shape(dataLabelsPropTypes),
  showProgress: PropTypes.bool,
  // mode: modePropType.isRequired,
  onSave: PropTypes.func,
  onPublish: PropTypes.func,
  onUnpublish: PropTypes.func,
  onCreateDraft: PropTypes.func
};

export default MarketSettingsForm;
